<template>
  <v-app>
    <v-app-bar fixed dark color="grey darken-2" height="56">
      <v-toolbar-title>TecZoa</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="irAlBlog">
        <v-icon>mdi-post-outline</v-icon>
      </v-btn>
      <v-btn icon @click="irATienda">
        <v-icon>mdi-store</v-icon>
      </v-btn>
      <v-btn icon @click="irAlCarrito">
        <v-badge :content="cantidadCarrito" :value="cantidadCarrito > 0" color="red" overlap>
          <v-icon>mdi-cart</v-icon>
        </v-badge>
      </v-btn>
      <AvatarUsuario />
    </v-app-bar>

    <v-main style="margin-top: 56px;">
      <router-view />
    </v-main>

    <FooterPerfilStore />
    <BotonFlotanteTienda />
    <SessionTimer />
  </v-app>
</template>

<script>
import FooterPerfilStore from '@/components/common/FooterPerfilStore';
import BotonFlotanteTienda from '@/components/common/navegacion/BotonFlotanteTienda.vue';
import AvatarUsuario from '@/components/common/navegacion/AvatarUsuario.vue';
import SessionTimer from '@/components/common/SessionTimer.vue';

export default {
  name: 'RutasStore',
  components: { FooterPerfilStore, BotonFlotanteTienda, AvatarUsuario, SessionTimer },
  computed: {
    cantidadCarrito() {
      return this.$store.getters.cantidadCarrito;
    }
  },
  methods: {
    irATienda() {
      if (this.$route.path !== '/store/all') {
        this.$router.push('/store/all');
      }
    },
    irAlBlog() {
      if (this.$route.path !== '/blog') {
        this.$router.push('/blog').catch(() => {});
      }
    },
    irAlCarrito() {
      if (this.$route.path !== '/store-carrito') {
        this.$router.push('/store-carrito');
      }
    }
  }
};
</script>
